<template>
  <div class="page border-box" v-wechat-title="$route.meta.title='我的畅听卡'">
    <!--<div class="top-fixed box border-box">-->
      <!--<div class="flex border-box">-->
        <!--<input type="text" placeholder="输入名称进行搜索">-->
      <!--</div>-->
    <!--</div>-->
    <div class="tab-box box">
      <div class="flex" :class="state==0?'curr':''" @click="tabFun(0)"><span><font>全部</font></span></div>
      <div class="flex" :class="state==4?'curr':''" @click="tabFun(4)"><span><font>平台VIP</font></span></div>
      <div class="flex" :class="state==5?'curr':''" @click="tabFun(5)"><span><font>景区VIP</font></span></div>
    </div>
    <div class="list border-box" v-if="total>0">
      <div class="item" v-for="(item,index) in root" :key="index" @click="toDesc(item)">
        <img class="img" src="../../assets/ar/img3.png" alt="" v-if="item.type==4">
        <img class="img" :src="item.logo" alt=""  v-if="item.type==5">
        <div class="bot box border-box">
          <div class="l flex">
            <p class="t1 hide">{{item.title}}</p>
            <p class="t2 hide" v-if="item.type==4">有效期至&nbsp;&nbsp;{{userRes.gdate}}</p>
          </div>
          <div class="r" :class="isGq==1?'dis':''">听讲解</div>
        </div>
      </div>
      <!--<div class="item">-->
        <!--<img class="img" src="../../assets/ar/img4.png" alt="">-->
        <!--<div class="bot box border-box">-->
          <!--<div class="l flex">-->
            <!--<p class="t1 hide">峨眉山景区畅听VIP</p>-->
            <!--<p class="t2 hide">有效期至：2024-03-10</p>-->
          <!--</div>-->
          <!--<div class="r" @click="toDesc">听讲解</div>-->
        <!--</div>-->
      <!--</div>-->
    </div>
    <p class="load-tip">{{loadText}}</p>

    <div class="no-data" v-if="total==0">
      <img src="../../assets/ar/no-data.png" alt="">
      <p>暂无内容！</p>
    </div>

    <!--<div class="alert-box" v-if="tipAlertShow==1">-->
      <!--<div class="mask" @click="tipAlertShow=0"></div>-->
      <!--<div class="alert-con tc">-->
        <!--<div class="t1">温馨提示</div>-->
        <!--<div class="t2">请点击您已购买的文创商品<br>进行AR互动体验！</div>-->
        <!--<div class="btn" @click="tipAlertShow=0"><span><font>我知道了</font></span></div>-->
      <!--</div>-->
    <!--</div>-->
  </div>

</template>

<script>
  import { mapState, mapMutations } from 'vuex'
  import {arUserActiveList} from "@/service/getData";
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'
  import wxConfirm from '@/wechat-messagebox/Confirm'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return{
        state:0,//顶部切换state 0全部 1 热门 2 最新
        loadText: "数据加载中",
        tipAlertShow:1,//提示弹窗显示与隐藏
        page: 1,
        rows: 10,
        loadText: "数据加载中",
        root:'',//评论列表
        total:'',//评论总条数
        userRes:'',//用户信息
        TimeStamp: new Date().getTime(),  //获取当前时间
        isGq:0,//平台会员是否过期 0：未过期 1：已过期
      }
    },
    computed: {

    },
    created() {
      this.$loading.show('数据加载中');
      this.userInfo = getStore("userInfo");
      this.initData(this.page);
      window.addEventListener("scroll",this.handleFun);
    },
    beforeDestroy(){
      window.removeEventListener("scroll",this.handleFun)
    },
    methods: {
      //获取列表
      async initData(page){
        var self = this;
        let res = await arUserActiveList({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
//          openid:'oUYE8xOECXhXEh9XHKC4OPOAhMug',
          page: page,
          rows: this.rows,
          state: this.state
        });
        if (res.errcode === "00000"){
          this.$loading.hide();
          console.log(res)
          this.total = res.data.total;
          this.userRes = res.data.user;
          let root = res.data.list;

          if(res.data.user.gdate){
            var strtime = res.data.user.gdate.replace("/-/g", "/");//时间转换
            //时间
            var date1 = new Date(strtime);
            //现在时间
            var date2 = new Date();
            //判断时间是否过期
            if(date1 < date2){
              self.isGq = 1;
            }else{
              self.isGq = 0;
            }
          }

          if (page >= Math.ceil(this.total / this.rows)) {
            this.loadText = '已经到底了'
          } else {
            this.loadText = '加载更多'
          }
          if (root.length > 0) {
            this.root = [...this.root, ...root];
          } else {
            if (page == 1) {
              this.root = [];
              this.loadText = '暂无数据'
            } else {
              this.loadText = '已经到底了'
            }
          }
        }
      },

      handleFun: function (){
        let self = this;
        self.$nextTick(function() {
          loadMore(self,function(page){
            self.initData(page);
          });
        })
      },

    //顶部切换
    tabFun(id){
      this.state = id;
      this.$loading.show('数据加载中');
      this.page = 1;
      this.root = [];
      this.initData(this.page);
    },

    //跳转
    toDesc(item){
      if(item.type==4){
        if(this.isGq!=1){
          this.$router.push({
            path: `/?`
          });
        }else{
          this.$toast('您的会员已过期，请及时续费~')
        }
      }
    },
  },
  components: {

  },
  //时间比较
  filters: {

  }

  }

</script>

<style scoped>
  @import "../../style/alert.css";
  .page{width: 100vw;min-height: 100vh;background-color:#ededed;}
  .top-fixed{position: fixed;top:0;left: 0;z-index: 1;width: 100%;height: .96rem;padding: .16rem .3rem;background-color: #fff;border-bottom: 1px solid #ededed;}
  .top-fixed .flex{height:.64rem;padding: .12rem .64rem;border-radius:.32rem;background: #f2f2f2 url(../../assets/ar/icon-search.png) no-repeat center;background-size: .24rem .26rem;background-position-x: .24rem;}
  .top-fixed .flex input{font-size: .28rem;line-height: .4rem;color: #333;background: none;}
  /*顶部切换分类*/
  .tab-box{position:fixed;z-index: 1;
    /*top:.96rem;*/
    top:0;left:0;width:100%;height:.96rem;text-align: center;background: #fff;}
  .tab-box .flex span{position: relative;display:inline-block;height:.96rem;font: bold .3rem/.96rem "Microsoft YaHei";color:#333;}
  .tab-box .flex.curr span{font-size: .34rem;}
  .tab-box .flex.curr span font{position: relative;z-index: 1;}
  .tab-box .flex.curr span:after{content: '';position: absolute;bottom: .32rem;left: 0;right: 0;height: .08rem;background-color: #ffc303;}
  .list{
    /*padding: 2.24rem .3rem 0;*/
    padding: 1.28rem .3rem 0;
  }
  .list .item{width: 100%;height:5rem;margin-top: .3rem;border-radius: .14rem;background: #fff;}
  .list .item:first-child{margin-top: 0;}
  .list .item .img{display: block;width:100%;height:3.8rem;border-radius: .14rem;}
  .list .item .bot{padding:.12rem .24rem;color:#222;}
  .list .item .t1{font:bold .32rem/.52rem "Microsoft YaHei";}
  .list .item .t2{font: .24rem/.44rem "Microsoft YaHei";color: #999;}
  .list .item .r{width:1.58rem;height:.64rem;margin-top:.18rem;margin-left: .12rem;text-align: center;border-radius: .32rem;font: bold .32rem/.64rem "Microsoft YaHei";background-color: #ffc303;}
  .list .item .r.dis{background-color: #e3e3e3;color: #999;}
  .no-data{padding-top: 2.8rem;}
  .no-data img{display: block;width: 51.33%;height: auto;margin: 0 auto;}
  .no-data p{text-align: center;margin-top: .4rem;font-size: .28rem;color: #cdcdcd;}

  /*提示弹窗*/
  .alert-con{position: absolute;top: 50%;left: 14vw;width: 72vw;padding-top:.44rem;background-color: rgba(242,242,242,.96);border-radius: .24rem;-webkit-transform: translateY(-50%);transform: translateY(-50%);}
  .alert-con .t1{font: bold .34rem "Microsoft YaHei";color: #000;}
  .alert-con .t2{margin-top:.1rem;font:  .26rem/.32rem "Microsoft YaHei";color: #000;}
  .alert-con .btn{width: 100%;margin-top: .38rem;height: .88rem;font: bold .34rem/.88rem "Microsoft YaHei";border-top: 1px solid #d3d3d3;color: #222;border-radius: 0 0 .24rem .24rem;}
  .alert-con .btn span{position: relative;}
  .alert-con .btn span font{position: relative;z-index: 1;}
  .alert-con .btn span:after {content: '';position: absolute;bottom: 0.06rem;left: 0;right: 0;height: 0.08rem;background-color: #ffc303;}
</style>



// WEBPACK FOOTER //
// src/page/ar/ar-list-jh.vue